var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.43139,
    cy: 5.89037,
    r: 5.20092,
    stroke: "#BBB8B8",
    strokeWidth: 0.520092
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17105 6.15013V9.01064H6.69115V6.15013H9.55165V5.63004H6.69115V2.76953H6.17105V5.63004H3.31055V6.15013H6.17105Z",
    fill: "#BBB8B8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInstagram);
export default __webpack_public_path__ + "static/media/addInstagram.2393c44a.svg";
export { ForwardRef as ReactComponent };